import { Component, Input, OnInit } from '@angular/core';
import { LeadService } from 'src/app/services/lead/lead.service';
import { LIFECYCLE_TYPES } from 'src/app/shared/constants';

@Component({
  selector: 'app-lifecycle-cards',
  templateUrl: './lifecycle-cards.component.html',
  styleUrls: ['./lifecycle-cards.component.scss']
})
export class LifecycleCardsComponent implements OnInit {

  @Input() leadId: number;

  lifecycleEvents: any[] = [];
  loading = true;

  constructor(private leadSrv: LeadService) {}

  ngOnInit() {
    if (this.leadId) {
      this.loadEvents();
    }
  }

  loadEvents() {
    this.loading = true;
    this.leadSrv.getLeadLifecycle(this.leadId).subscribe({
      next: (res: any) => {
        this.lifecycleEvents = (res.body || []).map((e: any) => {
          const typeInfo = LIFECYCLE_TYPES[+e.type] || { label: 'Unknown', colorClass: 'lc-secondary', iconClass: 'ri-question-line' };
          const utcCreation = typeof e.creation === 'string' && !e.creation.endsWith('Z') ? e.creation + 'Z' : e.creation;
          const dt = new Date(utcCreation);
          return {
            label:      typeInfo.label,
            colorClass: typeInfo.colorClass,
            iconClass:  typeInfo.iconClass,
            date:       dt.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }),
            time:       dt.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' }),
            user_name:  e.user_name,
          };
        });
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }
}
